module.exports = __webpack_public_path__ + "img/m-item01.11af2fe.png";